import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getTrainningSchdule = async () => {
  const response = await axios.get(`${base_url}trainningschdule`, config);

  return response.data;
};
const deleteTrainningSchdule = async (id) => {
  const response = await axios.delete(`${base_url}trainningschdule/${id}`, config);
  return response.data;
};
const getTrainningSchduleone = async (id) => {
  const response = await axios.get(`${base_url}trainningschdule/${id}`);
  return response.data;
};
const udpateTrainningSchdule = async (enq) => {
  const response = await axios.put(
    `${base_url}trainningschdule/${enq.id}`,
    { status: enq.enqData },
    config
  );
  return response.data;
};
const trainningschduleService = {
  getTrainningSchdule,
  deleteTrainningSchdule,
  getTrainningSchduleone,
  udpateTrainningSchdule,
};

export default trainningschduleService;
